module.exports = __webpack_public_path__ + "assets/measure_fuel_energy.97fab066.svg";